import React from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from "react-redux";
import { setServerInstance } from "../actions/searchAction";

//Ref: https://react-select.com/props

const options = [
  { value: 'Prod', label: 'Prod' },
  { value: 'Staging', label: 'Staging' },
  { value: 'Local', label: 'Local' },
]

export const InstanceCombobox = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  return (
    <div>
      <Select
        options={options}
        defaultValue={{ label: `${state.serverInstance}` }}
        onChange={(newValue, actionMeta) => dispatch(setServerInstance(newValue.value))} />
    </div>
  );
}
